const artifactIdRgx = /services\/+(.+?)\/+(.+?)\//

export function extractArtifactInfoFromScriptUrl(scriptUrl: string | undefined | null): {
	artifactId?: string | undefined | null
	artifactVersion?: string | undefined | null
} {
	if (scriptUrl == null) {
		return {}
	}
	const result = artifactIdRgx.exec(scriptUrl)
	return {
		artifactId: result?.[1],
		artifactVersion: result?.[2],
	}
}
